<ng-template #occurrenceCreation>
    <div class="modal-header" style="align-items: center">
        <h3 class="modal-title">Nova Ocorrência</h3>
        <button type="button" class="close" (click)="closeModal()" aria-label="Close">
            <i aria-hidden="true" class="fas fa-xmark"></i>
        </button>
    </div>
    <div class="modal-body">
        <!-- Dados da Sinalizão -->
        <div class="row" style="margin-bottom: 32px">
            <div class="col-4 mb-2">
                <label for="sign-type" class="form-label">Tipo de Sinalização</label>
                <input type="text" name="sign-type" class="form-control"
                    [ngModel]="signaling.type | enumText:'SignalingType'" disabled>
            </div>
            <div class="col-8 mb-2">
                <label for="sign-name" class="form-label">Sinalização</label>
                <input type="text" name="sign-name" class="form-control" [ngModel]="signaling.signName" disabled>
            </div>
            <div class="col-4">
                <label for="sign-location" class="form-label">
                    {{signaling.address.city ? 'Localização' : 'Latitude'}}
                </label>
                <input type="text" name="sign-location" class="form-control" [ngModel]="signaling.address.city"
                    *ngIf="signaling.address.city" disabled>
                <input type="text" name="sign-location" class="form-control" [ngModel]="signaling.lat"
                    *ngIf="!signaling.address.city" disabled>
            </div>
            <div class="col-4">
                <label for="sign-contract" class="form-label">
                    {{signaling.address.city ? 'Vínculo' : 'Longitude'}}
                </label>
                <input *ngIf="signaling.address.city" type="text" name="sign-contract" class="form-control" 
                    [ngModel]="signaling.contract.name" disabled>
                <input type="text" name="sign-location" class="form-control" [ngModel]="signaling.lng"
                    *ngIf="!signaling.address.city" disabled>
            </div>
            <div class="col-4">
                <label for="sign-createdAt" class="form-label">Data de Cadastramento</label>
                <input type="text" name="sign-createdAt" class="form-control"
                    [ngModel]="signaling.createdAt | date: 'dd/MM/yyyy'" disabled>
            </div>
        </div>
        <!-- /Dados da Sinalizão -->

        <!-- Formulário Ocorrência -->
        <div class="row">
            <div class="col-12 mb-2">
                <label for="description" class="form-label">Descrição*</label>
                <textarea class="form-control" name="description" id="description" rows="4"
                    [(ngModel)]="occurrence.description">
                </textarea>
            </div>
            <div class="col-12 d-flex flex-column">
                <label class="form-label">Imagens/Videos*</label>
                <small class="mb-3" style="color: var(--gray-base)">
                    *Vídeos são limitados a 10 segundos e 70MB.
                </small>
                <div class="d-flex mt-3 flex-column" style="min-height: 120px;">
                    <div class="d-flex flex-row align-items-center h-100 flex-wrap" style="gap: 16px">
                        <div class="btn btn-icon btn-icon-alt" style="margin: 36px 0" (click)="inputFile.click()">
                            <i class="fas fa-plus"></i>
                        </div>

                        <input type="file" class="d-none" #inputFile (change)="addFile($event.target.files)">

                        <div class="occurrence-image" *ngFor="let file of occurrence.files; index as i">
                            <img [src]="file.url" (click)="openFile(file.url)"
                                *ngIf="!file.type.includes('video'); else videoFile">
                            <div class="close-icon text-center" (click)="removeFile(i)">
                                <i class="fas fa-times" aria-hidden="true"></i>
                            </div>
                            <ng-template #videoFile>
                                <video [src]="file.url+'#t=2'" ></video>
                                <div class="play-icon" (click)="openFile(file.url)">
                                    <i class="fa-solid fa-play" aria-hidden="true"></i>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Formulário Ocorrência -->
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-primary" (click)="closeModal()">
            Cancelar
        </button>
        <button class="btn btn-primary" (click)="createOccurrence()">
            Criar
        </button>
    </div>
</ng-template>